<template>
    <div class="search__bar input-group mb-3 col-12">
        <input :class="classes"
               :placeholder="placeholder"
               :value="value"
               class="form-control"
               type="text"
               @input="$emit('input', $event.target.value)">
    </div>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        placeholder: String,
        classes: Array,
        value: String,
    },
};
</script>
